import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { EventItem } from "@/types";
import { events } from "@/mocks/events";
import { EventGridCard } from "@/components/base/EventCard";
import { LoadingState, EmptyState } from "@/components/base/StateViews";

export default function LatestNews() {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<EventItem[]>([]);

  function load() {
    setLoading(true);
    const timer = setTimeout(() => {
      const sorted = [...events].sort((a, b) => {
        if (a.date === b.date) return a.time < b.time ? 1 : -1;
        return a.date < b.date ? 1 : -1;
      });
      setList(sorted.slice(0, 6) as EventItem[]);
      setLoading(false);
    }, 600);
    return () => clearTimeout(timer);
  }

  useEffect(load, []);

  if (loading) return <LoadingState label="正在加载最新赛事资讯…" />;

  if (!list.length) {
    return (
      <EmptyState
        title="暂无赛事资讯"
        desc="今日还没有收录到新的赛事资讯，可以稍后刷新查看。"
        actionLabel="刷新资讯"
        onAction={load}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {list.map((e) => (
        <EventGridCard key={e.id} event={e} />
      ))}
      <Link
        to="/category/football"
        className="flex min-h-[220px] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-primary-300 bg-primary-50/50 p-6 text-center transition-colors hover:bg-primary-50"
      >
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-700">
          <i className="ri-more-line"></i>
        </span>
        <span className="text-base font-bold text-primary-800">浏览全部赛事资讯</span>
        <span className="text-sm text-foreground-500">按分类查看完整赛程与战报</span>
      </Link>
    </div>
  );
}